import { NgModule } from '@angular/core';
import { FiExpandableTextDirective } from './fi-expandable-text.directive';
import { CommonModule } from '@angular/common';
import { FiAppTextSharedModule } from '../app-text';

@NgModule({
    imports: [CommonModule, FiAppTextSharedModule],
    declarations: [FiExpandableTextDirective],
    exports: [FiExpandableTextDirective],
})
export class FiExpandableTextDirectiveModule {}
